module.exports = __webpack_public_path__ + "assets/icons/ic_info_24px.svg";